export default class WidgetNoteSettings {
    constructor(dto) {
        this.color = "";
        this.textColor = "";
        this.text = "";
        this.widgetTitle = "";
        this.checkBoxes = false;

        if (dto) {
            this.widgetTitle = dto.WidgetTitle;
            this.text = dto.Text;
            this.color = dto.Color || "#FFF59DFF";
            this.textColor = dto.TextColor || "#000000FF";
            this.checkBoxes = typeof(dto.CheckBoxes) == 'boolean' ? dto.CheckBoxes : dto.CheckBoxes == 'true';
        }
    }

    toDto() {
        return {
            WidgetTitle: this.widgetTitle,
            Text: this.text,
            TextColor: this.textColor,
            Color: this.color,
            CheckBoxes: this.checkBoxes
        };
    }
}